import { FC } from 'react';

import * as Meta from 'meta';
import { Footer, Header } from 'components';

export const PcStepPage: FC = () => {

  return (
    <div className="wrapper">
      {Meta.loadCSS(['notice', 'pcstep'])}
      {Meta.loadJS('main-0625')}
      {Meta.ga("電腦活動流程頁")}
      <Header />
      <div className="main">
        <section className="inner">
          <div id="step" className="step">
            <div className="title">
              <div className="title_t">手機掃描，立即抽獎</div>
              <div className="title_bg"><img src="/resources/html/images/title_bg.png" /></div>
            </div>
            <div className="step_topbox">
              <div className="step_toptext">立即拿出手機<br />掃描活動QRcode!<br />運用手機抽獎！</div>
              <div className="step_to">
                <img src="/resources/html/images/index/step_to.png" />
              </div>
              <div className="step_qrtop"><img src="/resources/html/images/index/qrcode.svg" /></div>
            </div>
            <div className="step_in">
              <ul className="step_box">
                <li className="step_s">
                  <div className="step_num">step.1</div>
                  <div className="step_pic">
                    <img src="/resources/html/images/index/step1.png" />
                  </div>
                  <div className="step_text">購買貼有<br />活動貼紙的爽啤</div>
                </li>
                <li className="step_s">
                  <div className="step_num">step.2</div>
                  <div className="step_pic">
                    <img src="/resources/html/images/index/step2.png" />
                  </div>
                  <div className="step_text">撕開罐身活動貼紙</div>
                </li>
                <li className="step_s">
                  <div className="step_num">step.3</div>
                  <div className="step_pic">
                    <img src="/resources/html/images/index/step3.png" />
                  </div>
                  <div className="step_text">使用手機掃描<br />活動QRcode</div>
                </li>
                <li className="step_s">
                  <div className="step_num">step.4</div>
                  <div className="step_pic">
                    <img src="/resources/html/images/index/step4.png" />
                  </div>
                  <div className="step_text">使⽤FB或Gmail<br />完成登錄</div>
                </li>
                <li className="step_s">
                  <div className="step_num">step.5</div>
                  <div className="step_pic">
                    <img src="/resources/html/images/index/step5.png" />
                  </div>
                  <div className="step_text">詳閱活動辦法<br />及注意事項</div>
                </li>
                <li className="step_s">
                  <div className="step_num">step.6</div>
                  <div className="step_pic">
                    <img src="/resources/html/images/index/step6.png" />
                  </div>
                  <div className="step_text">
                    立即顯示，即掃即抽結果<br />填寫資料後還有機會獲得更多大獎
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <div className="fwave fw1 ml"><img src="/resources/html/images/login/wave01.png" /></div>
        <div className="fwave fw2 mr"><img src="/resources/html/images/login/wave02.png" /></div>
        <div className="fwave fw3 ml"><img src="/resources/html/images/login/wave03.png" /></div>
        <div className="fwave fw4 mr"><img src="/resources/html/images/login/wave04.png" /></div>
      </div>
      <Footer />
      <div className="scroll_top"><span>TOP</span></div>
    </div>

  );
};
